import type { FC } from 'react';
import { Focusable, IconButton, Tooltip, TooltipTrigger } from '@launchpad-ui/components';

export interface SendStopButtonProps {
  /** Whether the agent is currently generating (toggles stop icon + onStopGeneration). */
  isAnalyzing: boolean;
  /** Loading state — shows a spinner in the legacy variant and the `sync` icon in the skills-UI variant. */
  disabled: boolean;
  /** Prompt textarea is empty. Computed by the parent because it owns prompt state. */
  isPromptEmpty: boolean;
  isAtUsageLimit: boolean;
  onStopGeneration?: () => void;
  handleSendPrompt: () => void;
}

export const SendStopButton: FC<SendStopButtonProps> = ({
  isAnalyzing,
  disabled,
  isPromptEmpty,
  isAtUsageLimit,
  onStopGeneration,
  handleSendPrompt,
}) => {
  const isSendDisabled = disabled || isPromptEmpty || isAtUsageLimit;

  let sendButtonTooltip: string | undefined;
  if (isAtUsageLimit) {
    sendButtonTooltip = 'You have reached your agent usage limit';
  } else if (isPromptEmpty && !disabled) {
    sendButtonTooltip = 'No message entered';
  }

  const sendIcon = isAnalyzing ? 'stop' : 'arrow-right-thin';
  const sendLabel = isAnalyzing ? 'Stop generating' : 'Send prompt';
  if (sendButtonTooltip) {
    return (
      <TooltipTrigger delay={0}>
        <Focusable>
          <IconButton icon={sendIcon} variant="primary" size="small" aria-label={sendLabel} isDisabled />
        </Focusable>
        <Tooltip placement="top">{sendButtonTooltip}</Tooltip>
      </TooltipTrigger>
    );
  }
  return (
    <IconButton
      icon={disabled ? 'sync' : sendIcon}
      variant="primary"
      size="small"
      aria-label={sendLabel}
      onPress={() => (isAnalyzing ? onStopGeneration?.() : handleSendPrompt())}
      isDisabled={isSendDisabled}
    />
  );
};
